import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCut$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCut extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4326dabecbdf6841bf504ee53dac663e506a862f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1295c4198acfca6a26a41ae9f89da6a336c3545b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'fc40045a5f048f23352447071999ed656e54cae2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m9.29 8.58 9.17 6.89a.28.28 0 0 1 .11.23.3.3 0 0 1-.3.3h-1.41a.57.57 0 0 1-.31-.1L11.28 12l-2 1.51a2.63 2.63 0 0 1 0 2.06 2.75 2.75 0 1 1-3-3.78 2.7 2.7 0 0 1 2.12.52l1.66-1.26-1.72-1.31a2.7 2.7 0 0 1-1.58.51 2.76 2.76 0 0 1-2.62-3.62 2.68 2.68 0 0 1 1.74-1.74 2.75 2.75 0 0 1 3.41 3.69m9-2.58a.3.3 0 0 1 .3.3.3.3 0 0 1-.1.22l-4 3.05a.5.5 0 0 1-.61 0l-.62-.49a.29.29 0 0 1-.12-.22.32.32 0 0 1 .11-.23l3.32-2.53a.5.5 0 0 1 .3-.1zM6.76 8.75a1.25 1.25 0 1 1-.02-2.5 1.25 1.25 0 0 1 .02 2.5m-1.162 6.235a1.25 1.25 0 1 0 2.304-.97 1.25 1.25 0 0 0-2.304.97", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-cut", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-cut"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-cut":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCut$1);
            }
            break;
    } });
}

const CosmosIconCut = CosmosIconCut$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCut, defineCustomElement };
